import React, { useState } from 'react'

import { Button, Typography, Select, Drawer, Paper } from '@telavita-core/react-design-kit'

import CustomIcons, { iconList } from '../CustomIcons'

import './ReportErrorModal.sass'

const ReportErrorModal = ({ open, setOpen, onSubmit }) => {
  const [selectedIssue, setSelectedIssue] = useState(null)
  const [description, setDescription] = useState('')
  const [isSubmitted, setIsSubmitted] = useState(false)

  const issueOptions = [
    { id: 'video', label: 'Problemas com vídeo' },
    { id: 'audio', label: 'Problemas com áudio' },
    { id: 'audio_video', label: 'Problema com áudio e vídeo' },
    { id: 'other', label: 'Outro' },
  ]

  const handleSelectIssue = (option) => {
    setSelectedIssue(option)
    setDescription('')
  }

  const handleSubmit = () => {
    const reportData = {
      message: description || null,
      reason: selectedIssue?.label,
    }

    onSubmit(reportData)
    setIsSubmitted(true)
  }

  const handleHardRefresh = () => {
    window.location.href = window.location.href.split('?')[0] + '?t=' + new Date().getTime()
  }

  const handleClose = () => {
    setSelectedIssue(null)
    setDescription('')
    setIsSubmitted(false)
    setOpen(false)
  }

  const isSubmitDisabled = !selectedIssue || (selectedIssue?.id === 'other' && !description.trim())

  return (
    <Drawer
      open={open}
      setOpen={handleClose}
      anchor='right'
    >
      {isSubmitted ? (
        <div className='ReportErrorModal' translate='no'>
          <Typography variant='header4' weight='bold'>
            Obrigado por reportar este erro!
          </Typography>

          <button className='ReportErrorModal__closeButton' onClick={handleClose}>
            <CustomIcons icon={iconList.X} />
          </button>

          <div className='ReportErrorModal__successContent'>
            <Typography variant='content2'>
              Vamos verificar e usar suas informações para melhorar nosso serviço.
            </Typography>

            {selectedIssue && selectedIssue.id !== 'other' && (
              <>
                <Typography variant='content2' weight='bold' customClassName='ReportErrorModal__guideTitle'>
                  Enquanto isso, se o problema persistir, tente:
                </Typography>

                <ol className='ReportErrorModal__guideList'>
                  <li>
                    <Typography variant='content2'>
                      <strong>Recarregar a página</strong>. Isso pode resolver o problema.
                    </Typography>
                  </li>
                  <li>
                    <Typography variant='content2'>
                      <strong>Verificar sua conexão</strong>, para confirmar se a internet está funcionando.
                    </Typography>
                  </li>
                  <li>
                    <Typography variant='content2'>
                      <strong>Testar áudio/vídeo</strong>. Verifique as configurações do seu dispositivo
                    </Typography>
                  </li>
                  <li>
                    <Typography variant='content2'>
                      <strong>Abrir em aba anônima</strong>. Para ignorar cache e extensões.
                    </Typography>
                  </li>
                  <li>
                    <Typography variant='content2'>
                      <strong>Usar outro navegador</strong>. Chrome ou Edge podem funcionar melhor
                    </Typography>
                  </li>
                </ol>
              </>
            )}
          </div>

          <Button
            onClick={handleClose}
            customClassName='ReportErrorModal__confirmButton'
            variant='contained'
          >
            Fechar
          </Button>
        </div>
      ) : (
        <div className='ReportErrorModal' translate='no'>
          <Typography variant='header4' weight='bold'>
            Reportar erro
          </Typography>

          <button className='ReportErrorModal__closeButton' onClick={handleClose}>
            <CustomIcons icon={iconList.X} />
          </button>

          <div className='ReportErrorModal__content'>

            <Paper variant='warning' customClassName='ReportErrorModal__disclaimer'>
              <Typography variant='content2' customClassName='ReportErrorModal__disclaimerText'>
                <b>Dica rápida: </b>muitos problemas de áudio e vídeo são resolvidos recarregando a página. Quer tentar?
              </Typography>
              <Button
                onClick={handleHardRefresh}
                customClassName='ReportErrorModal__refreshButton notranslate'
                variant='text'
                uppercase={false}
              >
                Recarregar agora
              </Button>
            </Paper>

            <div className='ReportErrorModal__selectWrapper'>
              <Select
                options={issueOptions}
                onSelect={handleSelectIssue}
                selected={selectedIssue}
                placeholder='Selecione o tipo de problema'
              />
            </div>

            {selectedIssue && (
              <div className='ReportErrorModal__descriptionWrapper'>
                <textarea
                  className='ReportErrorModal__textarea notranslate'
                  value={description}
                  onChange={(e) => setDescription(e.target.value.slice(0, 500))}
                  placeholder={
                    selectedIssue?.id === 'other'
                      ? 'Descreva o problema... (obrigatório)'
                      : 'Descreva o problema... (opcional)'
                  }
                  maxLength={500}
                />
                <Typography variant='caption' customClassName='ReportErrorModal__charCount'>
                  {description.length}/500 caracteres
                </Typography>
              </div>
            )}
          </div>

          <Button
            onClick={handleSubmit}
            customClassName='ReportErrorModal__submitButton notranslate'
            variant='contained'
            disabled={isSubmitDisabled}
          >
            Enviar
          </Button>
        </div>
      )}
    </Drawer>
  )
}

export default ReportErrorModal
